import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { UserInfo } from '../types/models';

export const useUserInfo = (): UserInfo | null => {
  const { accounts } = useMsal();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      setUserInfo({
        displayName: account.name || 'Unknown User',
        mail: account.username || '',
        userPrincipalName: account.username || '',
      });
    }
  }, [accounts]);

  return userInfo;
};